import { API_PREFIX } from './constant'
import { Request } from './request'

// 信息登记获取接口密钥
export interface GetApiKeyParams {
  name?: string // 机构名称
  thirdPartyName?: string // 对接开发商名称
  otherThirdPartyName?: string // 其他开发商名称
  phone?: string // 手机号码
  smsCode?: string // 短信验证码
}

export function getApiKey(params: GetApiKeyParams): Request {
  return {
    url: `${API_PREFIX}/blade-supervise/supervise/getApiKey`,
    method: 'POST',
    body: params,
  }
}
